import { Box } from '@material-ui/core';

import { Section } from '@/components/modules/Application/components/_shared/components/Section/Section';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';

interface ChangesReviewProps {
  originalDataTitleTextId: string;
  newDataTitleTextId: string;
  OriginalDataComponent: React.ReactNode;
  NewDataComponent: React.ReactNode;
}

export const ChangesReview = ({
  originalDataTitleTextId,
  newDataTitleTextId,
  OriginalDataComponent,
  NewDataComponent,
}: ChangesReviewProps) => {
  const { palette } = useCustomTheme();

  const { sm, md } = useScreen();
  const { getTextIdTranslation } = useTranslation();

  return (
    <Section>
      <Box
        display={'grid'}
        gridGap={md ? 30 : 20}
        alignItems={'flex-start'}
        gridTemplateColumns={sm ? 'minmax(0, 1fr) auto minmax(0, 1fr)' : '1fr'}
      >
        <FlexColumn gridGap={20}>
          <Font variant="h5" color="title">
            {getTextIdTranslation(originalDataTitleTextId)}
          </Font>
          {OriginalDataComponent}
        </FlexColumn>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          alignSelf={'center'}
          bgcolor={palette.secondary.contrastText}
          borderRadius="50%"
          width={md ? 50 : sm ? 40 : 60}
          height={md ? 50 : sm ? 40 : 60}
          mt={sm ? '40px' : 0}
          justifySelf={sm ? 'flex-start' : 'center'}
        >
          {sm ? (
            <Icon size={md ? 40 : 30} color={palette.secondary.main}>
              arrow_right
            </Icon>
          ) : (
            <Icon size={50} color={palette.secondary.main}>
              arrow_drop_down
            </Icon>
          )}
        </Box>
        <FlexColumn gridGap={20}>
          <Font variant="h5" color="title">
            {getTextIdTranslation(newDataTitleTextId)}
          </Font>
          {NewDataComponent}
        </FlexColumn>
      </Box>
    </Section>
  );
};
